<div class="device-location-off-alert">
  <h2 class="device-location-off-alert__title">
    {{ titleKey | translate }}
  </h2>
  <p class="device-location-off-alert__message">
    {{ messageKey | translate }}
  </p>
  <div class="device-location-off-alert__actions">
    <button
      type="button"
      class="device-location-off-alert__action device-location-off-alert__action--primary"
      (click)="openSettings()"
    >
      {{ 'LOCATION_PERMISSION_MODAL.OPEN_SETTINGS' | translate }}
    </button>
    <button
      type="button"
      class="device-location-off-alert__action"
      (click)="later()"
    >
      {{ 'LOCATION_PERMISSION_MODAL.LATER' | translate }}
    </button>
  </div>
</div>
